import React, { useState } from 'react';
import { Modal, Button, Form, Alert } from 'react-bootstrap';
import LoadingSpinner from '../common/LoadingSpinner';
import { validatePasswordChangeForm } from '../../utils/userValidation';
import PasswordFields from './fields/PasswordFields';

const ChangePasswordModal = ({ show, user, onSubmit, onClose }) => {
  const [formData, setFormData] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState([]);
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    return validatePasswordChangeForm(formData.newPassword, formData.confirmPassword);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);

    const validationErrors = validateForm();
    if (validationErrors.length > 0) {
      setErrors(validationErrors);
      return;
    }

    setSubmitting(true);
    const result = await onSubmit(formData.newPassword);
    setSubmitting(false);

    if (!result.success) {
      if (result.validationErrors) {
        setErrors(result.validationErrors);
      } else if (result.error) {
        setErrors([result.error]);
      }
    } else {
      setFormData({
        newPassword: '',
        confirmPassword: '',
      });
    }
  };

  const handleClose = () => {
    setFormData({
      newPassword: '',
      confirmPassword: '',
    });
    setErrors([]);
    onClose();
  };

  return (
    <Modal show={show && !!user} onHide={handleClose} centered>
      <Modal.Header closeButton className="bg-warning-subtle">
        <Modal.Title>Change Password</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          {errors.length > 0 && (
            <Alert variant="danger">
              <ul className="mb-0">
                {errors.map((error, index) => (
                  <li key={index}>{error}</li>
                ))}
              </ul>
            </Alert>
          )}

          <Alert variant="warning">
            Changing password for: <strong>{user?.displayName}</strong> ({user?.username})
          </Alert>

          <PasswordFields
            formData={formData}
            onChange={handleChange}
            passwordFieldName="newPassword"
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="warning" type="submit" disabled={submitting}>
            {submitting ? (
              <LoadingSpinner inline message="Changing..." />
            ) : (
              'Change Password'
            )}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;